// const BASE_URL = "http://localhost:3001";
// const BASE_URL = "http://api.seemyclouds.trangotechdevs.com:3013/"; // staging //TODO:
const BASE_URL = "https://api.seemyclouds.net/"; // live //TODO:

const API_URL = BASE_URL + "api/admin/";

const INITIAL_TOKEN = "e455e259-5ee7-449d-942a-a851af81813b";

export { API_URL, BASE_URL, INITIAL_TOKEN };
